import { Injectable, EventEmitter, inject } from '@angular/core';
import { UserDetail } from '../models/accounts.model';
import { StorageService } from './storage.service';

@Injectable({
  providedIn: 'root'
})
export class UserSettingService {
  private storageService = inject(StorageService);
  public static userProfileUpdated: EventEmitter<UserDetail> = new EventEmitter<UserDetail>();

  sendData(data: UserDetail) {
    this.storageService.add('user-profile', JSON.stringify(data));
    UserSettingService.userProfileUpdated.emit(data); // Emit the updated data
  }

  getData(): UserDetail {
    const data = this.storageService.get('user-profile');
    return data ? JSON.parse(data) : {} as UserDetail; // Ensure it returns an object
  }
}
